// extracted by mini-css-extract-plugin
module.exports = {"grid":"payroll-grid_grid__3mUqq"};